import React from 'react';
import MobileResults from './MobileResults';
import { TTimeFrame } from './MobileResults';
type MobileSearchResultsProps = {
  mode: string;
  resultsToUse: () => any[]; // Adjust type if necessary
  timeFrame: TTimeFrame;
  allTokens: any[]; // Adjust type if necessary
  onTokenClick: (token: any) => void; // Adjust type if necessary
  rowIsSelectedFunction: (row: any) => boolean; // Adjust type if necessary
  useUnprotectedSearch: boolean;
  setUseUnprotectedSearch: (value: boolean) => void;
};
const MobileSearchResults: React.FC<MobileSearchResultsProps> = ({
  mode,
  resultsToUse,
  timeFrame,
  allTokens,
  onTokenClick,
  rowIsSelectedFunction,
  useUnprotectedSearch,
  setUseUnprotectedSearch
}) => {
  return resultsToUse()?.length > 0 ? <>
      <div className='lg:hidden'>
        <>
          <MobileResults mode={mode} resultsToUse={mode === '' || mode == 'memes' ? resultsToUse()?.sort((a, b) => parseFloat(b?.['volume' + timeFrame]) - parseFloat(a?.['volume' + timeFrame])) : resultsToUse()} timeFrame={timeFrame} allTokens={allTokens} onTokenClick={onTokenClick} rowIsSelectedFunction={rowIsSelectedFunction} data-sentry-element="MobileResults" data-sentry-source-file="MobileSearchResults.tsx" />
          {mode === 'search' && !useUnprotectedSearch && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mb-4 mx-12 mt-4 text-[12px]' onClick={() => setUseUnprotectedSearch(true)}>
              Show Low Volume Results
            </div>}
        </>
      </div>
    </> : <div className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center mt-[150px] flex-col' data-sentry-component="MobileSearchResults" data-sentry-source-file="MobileSearchResults.tsx">
      {mode === 'search' ? 'No Safe Search Results' : mode === 'new' ? 'No New Tokens in the last 24 hours' : 'No Results'}

      {mode === 'search' && !useUnprotectedSearch && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => setUseUnprotectedSearch(true)}>
          Show Low Volume Results
        </div>}
    </div>;
};
export default MobileSearchResults;